// Number / date formatters

export const usd = (v) => {
  if (v === null || v === undefined || isNaN(Number(v))) return "—";
  const n = Number(v);
  const sign = n < 0 ? "-" : "";
  const abs = Math.abs(n).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${sign}$${abs}`;
};

export const num = (v, d = 0) => {
  if (v === null || v === undefined || isNaN(Number(v))) return "—";
  return Number(v).toLocaleString("en-US", {
    minimumFractionDigits: d,
    maximumFractionDigits: d,
  });
};

export const pct = (v, d = 2) => {
  if (v === null || v === undefined || isNaN(Number(v))) return "—";
  return `${Number(v).toFixed(d)}%`;
};

const MONTHS = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

export const ddmmmyy = (input) => {
  if (!input) return "—";
  // accept "DD-MMM-YYYY" / "DD-MMM-YY" / ISO
  let d;
  if (typeof input === "string") {
    const m = input.match(/^(\d{1,2})[- ]([A-Za-z]{3})[- ](\d{2,4})$/);
    if (m) {
      const day = m[1].padStart(2, "0");
      const mon = m[2].toUpperCase();
      const yr = m[3].length === 4 ? m[3].slice(2) : m[3];
      return `${day}-${mon}-${yr}`;
    }
    d = new Date(input);
  } else {
    d = new Date(input);
  }
  if (isNaN(d.getTime())) return String(input);
  const dd = String(d.getDate()).padStart(2, "0");
  const mon = MONTHS[d.getMonth()];
  const yr = String(d.getFullYear()).slice(2);
  return `${dd}-${mon}-${yr}`;
};

export const statusTone = (status) => {
  if (!status) return "neutral";
  const s = status.toUpperCase();
  if (s === "MATCH") return "match";
  if (s === "MINOR VARIANCE") return "warning";
  if (s === "MATERIAL VARIANCE") return "error";
  if (s === "REVIEW REQUIRED") return "info";
  return "neutral";
};

export const varianceTone = (v) => {
  if (v === null || v === undefined) return "neutral";
  const n = Number(v);
  if (Math.abs(n) < 0.01) return "match";
  return n > 0 ? "error" : "match";
};

// For P&L (sign is inverted vs variance): +ve = profit, -ve = loss
export const plTone = (pl) => {
  if (pl === null || pl === undefined) return "neutral";
  const n = Number(pl);
  if (Math.abs(n) < 0.01) return "info";
  return n > 0 ? "match" : "error";
};

export const plLabel = (pl) => {
  if (pl === null || pl === undefined) return "—";
  const n = Number(pl);
  if (Math.abs(n) < 0.01) return "Break-even";
  return n > 0 ? "Profit" : "Loss";
};
